// The "taste" film of meeting 1 on the home page (13.9.2026): Shlomo's voice
// and face, the savanna, the traffic jam, the four steps - five minutes.
// Every browser gets a session id; play/quartile/progress events go to
// video_events via log_video_event, and the session id is stamped on the
// account at the offer screen (claim_video_session) so we can answer the
// only question that matters: do people who watch buy?
import { useEffect, useRef } from "react";
import { supabase } from "../lib/supabase";

const SRC = "https://aflefkolkkxesvtdwyfd.supabase.co/storage/v1/object/public/media/film/seg1-taste-v10.mp4";
const POSTER = "https://aflefkolkkxesvtdwyfd.supabase.co/storage/v1/object/public/media/film/seg1-poster.jpg";
export const TASTE_SESSION_KEY = "taste_video_session";

function sessionId(): string {
  try {
    let s = window.localStorage.getItem(TASTE_SESSION_KEY);
    if (!s) {
      s = "tv_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      window.localStorage.setItem(TASTE_SESSION_KEY, s);
    }
    return s;
  } catch {
    return "tv_" + Math.random().toString(36).slice(2, 10);
  }
}

function utm(): unknown {
  try {
    const raw = window.localStorage.getItem("acq_utm_v1");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function TasteVideo() {
  const ref = useRef<HTMLVideoElement>(null);
  const sent = useRef<Set<string>>(new Set());
  const lastProgress = useRef(0);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const sid = sessionId();
    const log = (event: string, pos?: number) => {
      if (event !== "progress") {
        if (sent.current.has(event)) return;
        sent.current.add(event);
      }
      supabase
        .rpc("log_video_event", {
          _session: sid,
          _event: event,
          _pos: pos == null ? null : Math.round(pos),
          _path: window.location.pathname,
          _utm: utm(),
          _video: "seg1",
        })
        .then(() => undefined, () => undefined);
    };
    const onPlay = () => log("start", v.currentTime);
    const onTime = () => {
      if (!v.duration) return;
      const f = v.currentTime / v.duration;
      if (f >= 0.25) log("q25", v.currentTime);
      if (f >= 0.5) log("q50", v.currentTime);
      if (f >= 0.75) log("q75", v.currentTime);
      // a heartbeat every 30 s of playback - tells us where people leave
      if (v.currentTime - lastProgress.current >= 30) {
        lastProgress.current = v.currentTime;
        log("progress", v.currentTime);
      }
    };
    const onEnded = () => log("q100", v.duration);
    v.addEventListener("play", onPlay);
    v.addEventListener("timeupdate", onTime);
    v.addEventListener("ended", onEnded);
    return () => {
      v.removeEventListener("play", onPlay);
      v.removeEventListener("timeupdate", onTime);
      v.removeEventListener("ended", onEnded);
    };
  }, []);

  return (
    <div className="taste-video">
      <div className="taste-video-title">🎬 המפגש הראשון, בחמש דקות</div>
      <div className="taste-video-sub">שלמה מספר, בקולו, את הכלי שעובד תוך שלוש שניות. לפני שקונים.</div>
      <video
        ref={ref}
        src={SRC}
        poster={POSTER}
        controls
        playsInline
        preload="metadata"
        controlsList="nodownload"
      />
    </div>
  );
}
